export default "Isolation thermique des points singuliers (vannes, brides, supports, échangeurs) des réseaux process et utilités via matelas démontables : fiche CEE IND-UT-103. Pertes thermiques limitées, maintenance préservée.";
